import React, { useEffect, useState } from 'react';

const calculateTimeLeft = () => {
  const targetDate = new Date('2024-07-20T19:30:00-04:00');
  const difference = +targetDate - +new Date();
  let timeLeft = {};

  if (difference > 0) {
    const day = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const mins = Math.floor((difference / 1000 / 60) % 60);
    const secs = Math.floor((difference / 1000) % 60);

    timeLeft = {
      ...(day > 0 && { day }),
      hours: hours < 10 ? hours : hours,
      mins: mins < 10 ? mins : mins,
      secs,
    };
  }

  return timeLeft;
};

const CountdownTimer = ({ onEnd }) => {
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [hasEnded, setHasEnded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);
      if (Object.keys(newTimeLeft).length === 0) {
        setHasEnded(true);
        onEnd(); // Notify parent component that the timer has ended
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, [timeLeft, onEnd]);

  const timerComponents = [];

  Object.keys(timeLeft).forEach((interval) => {
    if (!timeLeft[interval]) {
      return;
    }

    let intervalLabel = interval;

    if (interval === 'hours' && timeLeft[interval] < 10) {
      intervalLabel = 'hour';
    } else if (interval === 'mins' && timeLeft[interval] < 10) {
      intervalLabel = 'min';
    }

    timerComponents.push(
      <span key={interval}>
        {timeLeft[interval]} {intervalLabel}{' '}
      </span>
    );
  });

  if (hasEnded) {
    return null; // Timer has ended, return null to hide it
  }

  return (
    <span className="countdown-timer">
      {timerComponents.length ? timerComponents : <span>Show is up now!</span>}
    </span>
  );
};

export default CountdownTimer;
